import { File } from '@dev-streetbeat/chat';
import { FileDisplayType } from 'types/FileDisplayTypes';

const getFileDisplayType = (file: File) => {
  if (!file) return '';
  const fileExtension = file.name.split('.').pop();

  if (file.type === 'application/pdf') {
    return FileDisplayType.PDF;
  } else if (file.type.startsWith('image/svg')) {
    return FileDisplayType.SVG;
  } else if (file.type.startsWith('image/')) {
    return FileDisplayType.IMAGE;
  } else if (file.type === 'text/csv') {
    return FileDisplayType.XLSX;
  } else if (file.type === 'text/plain') {
    return FileDisplayType.TEXT;
  } else {
    return fileExtension?.toUpperCase() as FileDisplayType;
  }
};

export { getFileDisplayType };
